import find from 'lodash/find'
import get from 'lodash/get'

export const getDepFromNav = (navigation, pathName) => {
  const pathParsed = pathName
  const items = []
  let itemSelected = {}

  if (!!pathParsed) {
    navigation?.map((pqueue) => {
      pqueue?.map((queue) => {
        queue?.contentData?.map((entry) => {
          items.push(entry)
        })
      })
    })

    items?.map((item) => {
      if (item?.path?.endsWith(pathParsed)) {
        itemSelected = item
      }
    })
  }

  return itemSelected
}

export const getPageTitleFromPath = (nav, d) => {
  const getFromList = (p) => get(find(nav, { path: p }), 'name')
  const slugs = []
  const s = d.split('/')

  if (s.length > 3) {
    slugs.push(`/${s[1]}/${s[2]}/${s[3]}`)
  }
  else if (s.length > 2) {
    slugs.push(`/${s[1]}/${s[2]}`)
  }
  else if (s.length > 1) {
    slugs.push(`/${s[1]}`)
  }

  const titles = []
  for (let i = 0; i < slugs.length; i++) {
    titles.push(getFromList(slugs[i]))
  }

  return titles
}
